import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export type InviteUserRequest = {
  firstName: string
  lastName: string
  email: string
  phone: string | null
  isActive: boolean
}

export const inviteUser = async (
  params: InviteUserRequest
) => {
  await api.post("/invites/", { body: params })

  queryClient.invalidateQueries([USERS_QUERY_KEY])
}
